import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {  loadRecentMenuList, menuModule } from '../MenuDucks';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import FilterSelect from '../../../components/TableFilter/ColumnsFilters/FilterSelect';
import { menuColumns } from '../MenuColumns';
import useDict from '../../../components/_hooks/useDict';
import { Table } from '../../ServiceProvidersPage/ServiceProvidersStyles';
import Pagination from '@material-ui/lab/Pagination';
import { formatDate } from '../MenuUtils';

export default function MenuRecentListDialog({ open, close, onSelect }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const ageGroupsDict = useDict('gu_age_group') || [];
  const ageGroups = ageGroupsDict
    .filter(item => item.View === 'true')
    .map(item => ({ code: item.code, name: item.ru_name || item.kk_name }));

  const { recentMenuTableData, loadingTable } = useSelector(
    state => state[menuModule]
  );

  const { filter, toPage, changeFilter } = useTableFilter(
    (filter) => {
      if (!filter.startDate || !filter.ageGroupId) return;
      const menuFilter = { ...filter };
      dispatch(loadRecentMenuList(menuFilter));
    },
    undefined,
    'recentMenuList'
  );
  const formattedTableData = recentMenuTableData.content.flatMap(row => {
    return row.menuItems.map(menuItem => ({
      ...menuItem,
      ageGroupId: row.ageGroupId,
      serviceProviderId: row.serviceProviderId,
      isActive: row.isActive
    }));
  });

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="lg">
      <DialogTitle>
        {t("menuPage_recentMenus") || "Последние меню"}
      </DialogTitle>

      <DialogContent>
        <Box className="flex items-center mt2" style={{ gap: 20 }}>
          <Box className="flex items-center">
            <Typography style={{ fontSize: "14px", width: "140px" }}>
              {t("menuPage_startDate")}
            </Typography>

            <TextField
              type="date"
              value={filter.startDate || ''}
              onChange={(e) => {
                const raw = e.target.value;
                const formatted = formatDate(raw);
                changeFilter({ startDate: formatted });
              }}
            />
          </Box>
          <Box className="flex items-center">
            <Typography style={{ fontSize: "14px", width: "140px" }}>
              {t("menuPage_ageGroup")}
            </Typography>

            <FilterSelect
              name="ageGroupId"
              options={ageGroups.map(item => ({
                code: item.code,
                ru_name: item.name,
                kk_name: item.name
              }))}
              lang={i18n.language}
              fullWidth={false}
              style={{ marginRight: 10, width: 150 }}
              placeholder={t('contingentPage_group')}
              value={filter.ageGroupId || ''}
              onChange={(e) => {
                changeFilter({ ageGroupId: e.target.value });
              }}            />
          </Box>

        </Box>
        <Box mt={3}>
          <Table
            columns={menuColumns({
              t,
              lang: i18n.language,
              isFromRecentListMenu:true
            })}
            data={formattedTableData}
            totalElements={recentMenuTableData?.totalElements || 0}
            loading={loadingTable}
            sortable={false}
            // onClickLoadMore={() => nextPage()}
          />
          <Pagination
            onChange={(e, page) => toPage(page)}
            page={filter.pageNumber}
            count={Math.ceil(recentMenuTableData.totalElements / filter.pageSize)}
            style={{ marginTop: 10 }}
            variant="outlined"
            shape="rounded"
          />
        </Box>

      </DialogContent>

      <DialogActions>
        <Button onClick={close} color="secondary">
          {t("menuPage_close")}
        </Button>
        <Button
          onClick={() => {
            onSelect(recentMenuTableData.content);
          }}
          color="primary"
        >
          {t("menuPage_addMenu")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
